import { useMsal } from '@azure/msal-react';
import { getAccessToken } from '@monorepo/shared/src/config/educatorApp/auth';
import { useEffect } from 'react';
import useLoginSuccess from './useLoginSuccess';
import useSSO from './useSSO';
import useUserStore from '@monorepo/shared/src/graph/hooks/use-user';
import useLoginSuccessTelemetry from '@monorepo/shared/src/hooks/use-login-success-telemetry';
import {
  getAuthHeaders,
  Header,
} from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { AuthenticationSource } from '@monorepo/shared/src/graph/schema-generated-types-educator';

const useLoginTelemetry = (useAuth, instance) => {
  const azureContext = useMsal();
  const [loginSuccess] = useLoginSuccess(instance);
  const [authenticationSource, { maybeStripParamsAndRedirect }] = useSSO();
  const fireLoginSuccessEvent = useLoginSuccessTelemetry(
    authenticationSource as AuthenticationSource
  );
  const getSignature = (accessToken) => accessToken?.split('.')[2] ?? [];
  const [{ isAuthenticated }] = useUserStore();

  useEffect(() => {
    async function loginSuccessTelemetry() {
      if (!isAuthenticated) return;

      const result = await getAccessToken(azureContext);
      const sessionId = useAuth
        ? getSignature(result?.accessToken)
        : getAuthHeaders()[Header.AUTH_TOKEN];

      if (loginSuccess || (!useAuth && authenticationSource !== AuthenticationSource.LWT)) {
        fireLoginSuccessEvent({ sessionId });
        maybeStripParamsAndRedirect();
      }
    }

    loginSuccessTelemetry();
  }, [azureContext, loginSuccess, isAuthenticated, useAuth]);
};

export default useLoginTelemetry;
